// Словари для склонения чисел
export const pluralize = {
  periodDays: {
    1: 'в сутки',
    one: 'на {} день',
    few: 'на {} дня',
    many: 'на {} дней',
  },
  daysLeft: {
    one: '(остался {} день)',
    few: '(осталось {} дня)',
    many: '(осталось {} дней)',
  },
  packages: {
    one: '{} объявление',
    few: '{} объявления',
    many: '{} объявлений',
  },
  usersAccusative: {
    one: '{} пользователя',
    few: '{} пользователей',
    many: '{} пользователей',
  },
  auctionOffersAccusative: {
    one: '{}+ объявление',
    few: '{}+ объявления',
    many: '{}+ объявлений',
  },
  auctionConcurrencyOffersAccusative: {
    one: 'объявление',
    few: 'объявления',
    many: 'объявлений',
  }
};

// Причины недоступности услуги
export const unavailableReasons = {
  noPhotos: {
    message: 'Только для объявлений с фотографиями',
  },
  onlyInAction: {
    message: 'Только для аккаунтов с идентификацией по документам',
  },
  deniedBySanctions: {
    message: 'Заблокировано модератором',
    hint: 'Подробнее о причинах запрета и дальнейших действиях можно узнать в <a href="https://www.cian.ru/help/quality/37646/" target="_blank">Справочном центре</a>',
  },
  top3ServiceDenied: {
    message: 'Размещение Топ-объявления недоступно',
  },
  onlyAfterPremiumServiceExpiration: {
    message: 'Недоступно, дождитесь окончания периода публикации «Премиум»',
  },
};

// Подсказки для условий
export const hints = {
  'premium+highlight': {
    multiplier: 4,
    text: [
      'Объявление показывается в результатах поиска<br>в приоритетном порядке над платными объявлениями и выделяется жёлтым цветом на фоне конкурентов.',
      'Яркий жёлтый фон привлечёт дополнительное внимание к вашему объявлению и оно не затеряется среди тысячи похожих предложений.',
      'В среднем в 4 раза чаще показываем ваше объявление клиентам.'
    ],
  },
  'premium+highlight+auction': {
    multiplier: 4,
    text: [
      'Аукцион – это способ увеличить частоту показов вашего объявления. Чем выше ставка, тем выше позиция вашего объявления.',
      'Вы решаете какой объём звонков получит объявление.'
    ],
  },
  top3: {
    multiplier: 5,
    text: [
      'Вы получаете в 5 раз больше звонков, а значит, многократно увеличиваете скорость сделки.',
      'Топ-объявления самые заметные в результатах поиска за счёт больших фотографий и брендирования. Такие объявления показываются на первых позициях, до всех остальных объявлений.',
    ],
  },
  'top3+auction': {
    multiplier: 5,
    text: [
      'Аукцион – это способ увеличить частоту показов вашего объявления. Чем выше ставка, тем выше позиция вашего объявления.',
      'Вы решаете какой объём звонков получит объявление.'
    ],
  },
  premium: {
    multiplier: 3,
    text: [
      'В 3 раза больше звонков, а значит в 3 раза выше скорость продажи.',
      'Премиум объявления выделены в результатах поиска за счёт брендирования. Такие объявления будут показаны сразу после блока Топ-объявлений.',
    ],
  },
  'premium+auction': {
    multiplier: 3,
    text: [
      'Аукцион – это способ увеличить частоту показов вашего объявления. Чем выше ставка, тем выше позиция вашего объявления.',
      'Вы решаете какой объём звонков получит объявление.'
    ],
  },
  paid: {
    text: [
      'Платные объявления никак не выделяются в результатах поиска и показываются ниже всех Топ и Премиум объявлений.',
      'Хотите ускорить продажу? Установите ставку на Аукцион или выбирайте Премиум размещение!',
    ],
  },
  'paid+auction': {
    text: [
      'Аукцион – это способ увеличить частоту показов вашего объявления. Чем выше ставка, тем выше позиция вашего объявления.',
      'Вы решаете какой объём звонков получит объявление.',
    ],
  },
  free: {
    text: [
      'Объявление ничем не выделено на фоне других и показывается в самом конце списка — после платных объявлений.',
    ],
  },
  'free+auction': {
    text: [
      'Аукцион – это способ увеличить частоту показов вашего объявления. Чем выше ставка, тем выше позиция вашего объявления.',
      'Вы решаете какой объём звонков получит объявление.'
    ],
  },
  highlight: {
    multiplier: '1,5',
    text: [
      'Яркий жёлтый фон привлечёт дополнительное внимание к вашему объявлению и оно не затеряется среди тысячи похожих предложений.',
      'Выделение цветом можно добавить к любому способу размещения, кроме Топа.',
    ],
  },
};

// Подсказки для условий
export const hintsML = {
  'premium+highlight': {
    multiplier: 4,
    text: [
      'Объявления "Премиум + Выделение цветом" выделены ярким цветом, а также дополнительными фотографиями. Такие объявления показываются в 2 раза чаще обычных.',
    ],
  },
  'premium+highlight+auction': {
    multiplier: 4,
    text: [
      'Аукцион – это способ увеличить частоту показов вашего Премиум-объявления. Чем выше ставка, тем чаще ваш Премиум будет показан в результатах поиска.',
    ],
  },
  top3: {
    multiplier: 5,
    text: [
      'Топ-объявления самые заметные в результатах поиска за счёт больших фотографий и брендирования. Такие объявления показываются в 3 раза чаще обычных.',
    ],
  },
  premium: {
    multiplier: 3,
    text: [
      'Премиум-объявления выделены в результатах поиска за счёт дополнительных фотографий. Такие объявления показываются в 1.5 раза чаще обычных.',
    ],
  },
  'premium+auction': {
    multiplier: 3,
    text: [
      'Аукцион – это способ увеличить частоту показов вашего Премиум-объявления. Чем выше ставка, тем чаще ваш Премиум будет показан в результатах поиска.',
    ],
  },
  paid: {
    text: [
      'Платные объявления никак не выделяются в результатах поиска и показываются в 3 раза реже, чем Топ-объявления.',
    ],
  },
  free: {
    text: [
      'Бесплатные объявления реже всего попадают в результаты поиска и никак не выделяются на фоне других объявлений.',
    ],
  },
  'free+auction': {
    text: [
      'Аукцион – это способ увеличить частоту показов вашего объявления. Чем выше ставка, тем выше позиция вашего объявления.',
      'Вы решаете какой объём звонков получит объявление.'
    ],
  },
  highlight: {
    multiplier: '1,5',
    text: [
      'Ваше объявление будет выделено ярким цветом на фоне других объявлений.',
    ],
  },
};

export const unavailableReasonsML = {
  noPhotos: {
    message: 'Только для объявлений с фотографиями',
  },
  onlyInAction: {
    message: 'Только для участников программы «Работаем честно»',
  },
  deniedBySanctions: {
    message: 'Заблокировано модератором',
    hint: 'Подробнее о причинах запрета и дальнейших действиях можно узнать в <a href="https://www.cian.ru/help/quality/37646/" target="_blank">Справочном центре</a>',
  },
  top3ServiceDenied: {
    message: 'Размещение Топ недоступно',
  },
  onlyAfterPremiumServiceExpiration: {
    message: 'Недоступно, дождитесь окончания периода публикации «Премиум»',
  },
};

export const expositionsML = {
  paid: {
    name: 'Платное',
    time: {
      flatSale: 45,
      flatRent: 15,
    },
    buttons: {
      flatSale: [
                { text: 'Топ', time: 22, id: 'top3' },
                { text: 'Премиум + Выделение цветом', time: 30, id: 'premium+highlight' },
      ],
      flatRent: [
                { text: 'Топ', time: 7, id: 'top3' },
                { text: 'Премиум + Выделение цветом', time: 9, id: 'premium+highlight' },
      ],
    },
  },
  premium: {
    name: 'Премиум',
    time: {
      flatSale: 35,
      flatRent: 10,
    },
    buttons: {
      flatSale: [
                { text: 'Топ', time: 22, id: 'top3' },
                { text: 'Премиум + Выделение цветом', time: 30, id: 'premium+highlight' },
      ],
      flatRent: [
                { text: 'Топ', time: 7, id: 'top3' },
                { text: 'Премиум + Выделение цветом', time: 9, id: 'premium+highlight' },
      ],
    },
  },
  'premium+highlight': {
    name: 'Премиум + Выделение цветом',
    time: {
      flatSale: 30,
      flatRent: 9,
    },
    buttons: {
      flatSale: [
                { text: 'Топ', time: 22, id: 'top3' },
      ],
      flatRent: [
                { text: 'Топ', time: 7, id: 'top3' },
      ],

    },
  },
  free: {
    name: 'Бесплатное',
    time: {
      flatSale: 45,
      flatRent: 21,
    },
    buttons: {
      flatSale: [
        { text: 'Топ', time: 22, id: 'top3' },
        { text: 'Премиум + Выделение цветом', time: 30, id: 'premium+highlight' },
      ],
      flatRent: [
        { text: 'Топ', time: 7, id: 'top3' },
        { text: 'Премиум + Выделение цветом', time: 9, id: 'premium+highlight' },
      ],
    },
  },
};

// Подсказки - "За сколько я продам объект"
export const expositions = {
  paid: {
    name: 'Платное',
    time: {
      flatSale: 45,
      flatRent: 15,
    },
    buttons: {
      flatSale: [
                { text: 'Топ', time: 22, id: 'top3' },
                { text: 'Премиум + Выделение цветом', time: 30, id: 'premium+highlight' },
      ],
      flatRent: [
                { text: 'Топ', time: 7, id: 'top3' },
                { text: 'Премиум + Выделение цветом', time: 9, id: 'premium+highlight' },
      ],
    },
  },
  premium: {
    name: 'Премиум',
    time: {
      flatSale: 35,
      flatRent: 10,
    },
    buttons: {
      flatSale: [
                { text: 'Топ', time: 22, id: 'top3' },
                { text: 'Премиум + Выделение цветом', time: 30, id: 'premium+highlight' },
      ],
      flatRent: [
                { text: 'Топ', time: 7, id: 'top3' },
                { text: 'Премиум + Выделение цветом', time: 9, id: 'premium+highlight' },
      ],
    },
  },
  'premium+highlight': {
    name: 'Премиум + Выделение цветом',
    time: {
      flatSale: 30,
      flatRent: 9,
    },
    buttons: {
      flatSale: [
                { text: 'Топ', time: 22, id: 'top3' },
      ],
      flatRent: [
                { text: 'Топ', time: 7, id: 'top3' },
      ],

    },
  },
  free: {
    name: 'Бесплатное',
    time: {
      flatSale: 45,
      flatRent: 21,
    },
    buttons: {
      flatSale: [
        { text: 'Топ', time: 22, id: 'top3' },
        { text: 'Премиум + Выделение цветом', time: 30, id: 'premium+highlight' },
      ],
      flatRent: [
        { text: 'Топ', time: 7, id: 'top3' },
        { text: 'Премиум + Выделение цветом', time: 9, id: 'premium+highlight' },
      ],
    },
  },
};
